import ZIcon from '../custom/ZIcon.js';
import {doc} from './docs.js';

doc(
    "icon",
    {
    },
    "creates an icon with supplied",
    () => 0,
    {
        inlets: 0
    });
export const icon = (object) => {
    let icon = new ZIcon(object);
    return () => {
        
    };
};
